module.exports = __webpack_public_path__ + "static/media/account_circle.64b00b33.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/account_circle.svg
// module id = 1782
// module chunks = 0